
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index__JsULEBT7Rl_3xd0ZcmLYP54dEALiGtRyOU5rfOiWkMeta } from "/home/runner/work/web-frontend/web-frontend/app/pages/index.vue?macro=true";
import { default as search1onfMyEyUqcL41PBdYEL6kNIXCQLeIZMcXj8aAq6b88Meta } from "/home/runner/work/web-frontend/web-frontend/app/pages/search.vue?macro=true";
import { default as articlevhw7NfkSHpuKvV5Bcpba_htiPtOAzaybz3RBNOG8IdwMeta } from "/home/runner/work/web-frontend/web-frontend/app/pages/article.vue?macro=true";
import { default as _91_46_46_46uri_93Z05IBM_faS5GYfpAIyqFa81GS1jZM87ZwoniYrad7FoMeta } from "/home/runner/work/web-frontend/web-frontend/app/pages/[...uri].vue?macro=true";
import { default as indexOvsE9gVQRK_1zFrtNbktLvyrMVz2FblaIlfwiN2MdxwMeta } from "/home/runner/work/web-frontend/web-frontend/app/pages/block-tests/index.vue?macro=true";
import { default as _91block_93kdit9c8mx9iMQKJyU2OcNByXZ_dG9v7Oswb9qLu1BEwMeta } from "/home/runner/work/web-frontend/web-frontend/app/pages/block-tests/[block].vue?macro=true";
import { default as configjrviR9FOd3N5h_d_HgaYbyj4hmjPlmG03LpE3xoTXHcMeta } from "/home/runner/work/web-frontend/web-frontend/app/pages/block-tests/blocks/ds_TabsBlock/config.js?macro=true";
import { default as config7LJoxgNOhZ3Yh_rZOP9nWYnfoloGXxi5wcxIjNlJyXMMeta } from "/home/runner/work/web-frontend/web-frontend/app/pages/block-tests/blocks/ds_ImagesBlock/config.js?macro=true";
import { default as configlIJhoXq2QFkh1hm32lKVHhndVQRYLtYSn8dco1__FNAMeta } from "/home/runner/work/web-frontend/web-frontend/app/pages/block-tests/blocks/ds_GalleryBlock/config.js?macro=true";
import { default as config9yT4msF_A6KgZ0j_lnYHw38ZOmSHjXEVA_7glsGT8L8Meta } from "/home/runner/work/web-frontend/web-frontend/app/pages/block-tests/blocks/ds_ButtonGroupBlock/config.js?macro=true";
import { default as block_45teststQU4S8iH2H8O1E5CDFBlG1ulZ1oK6o_m5uZ0s1ZZlkUMeta } from "/home/runner/work/web-frontend/web-frontend/app/pages/block-tests.vue?macro=true";
import { default as _91article_93IqccQ9wH7nUPGIkxdh2ZIR2lHe83J5SQr2YWItrq72YMeta } from "/home/runner/work/web-frontend/web-frontend/app/pages/news-feed/[article].vue?macro=true";
import { default as indexy14Eq8bZctM1QAkVcUWriyRrEWnsuIVy7KBH5_CmV_YMeta } from "/home/runner/work/web-frontend/web-frontend/app/pages/newsletters/[newsletter]/index.vue?macro=true";
import { default as _91article_93UItYmtj4olPAGLLxHlcPd7J8rBpszZgtKgOgAkgBWcwMeta } from "/home/runner/work/web-frontend/web-frontend/app/pages/newsletters/[newsletter]/[article].vue?macro=true";
import { default as component_45stubfxzDPZss3Yt2CkyB1dMX7HanFvYboSw4k6OXAK36gdAMeta } from "/home/runner/work/web-frontend/web-frontend/node_modules/.pnpm/nuxt@4.0.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.1.0_@vue+compiler-sfc@3._6kghvrrpnemucoi63bxjk4w3ju/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubfxzDPZss3Yt2CkyB1dMX7HanFvYboSw4k6OXAK36gdA } from "/home/runner/work/web-frontend/web-frontend/node_modules/.pnpm/nuxt@4.0.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.1.0_@vue+compiler-sfc@3._6kghvrrpnemucoi63bxjk4w3ju/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/web-frontend/web-frontend/app/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/home/runner/work/web-frontend/web-frontend/app/pages/search.vue")
  },
  {
    name: "article",
    path: "/article",
    component: () => import("/home/runner/work/web-frontend/web-frontend/app/pages/article.vue")
  },
  {
    name: "uri",
    path: "/:uri(.*)*",
    component: () => import("/home/runner/work/web-frontend/web-frontend/app/pages/[...uri].vue")
  },
  {
    name: block_45teststQU4S8iH2H8O1E5CDFBlG1ulZ1oK6o_m5uZ0s1ZZlkUMeta?.name,
    path: "/block-tests",
    meta: block_45teststQU4S8iH2H8O1E5CDFBlG1ulZ1oK6o_m5uZ0s1ZZlkUMeta || {},
    component: () => import("/home/runner/work/web-frontend/web-frontend/app/pages/block-tests.vue"),
    children: [
  {
    name: "block-tests",
    path: "",
    component: () => import("/home/runner/work/web-frontend/web-frontend/app/pages/block-tests/index.vue")
  },
  {
    name: "block-tests-block",
    path: ":block()",
    component: () => import("/home/runner/work/web-frontend/web-frontend/app/pages/block-tests/[block].vue")
  },
  {
    name: "block-tests-blocks-ds_TabsBlock-config",
    path: "blocks/ds_TabsBlock/config",
    component: () => import("/home/runner/work/web-frontend/web-frontend/app/pages/block-tests/blocks/ds_TabsBlock/config.js")
  },
  {
    name: "block-tests-blocks-ds_ImagesBlock-config",
    path: "blocks/ds_ImagesBlock/config",
    component: () => import("/home/runner/work/web-frontend/web-frontend/app/pages/block-tests/blocks/ds_ImagesBlock/config.js")
  },
  {
    name: "block-tests-blocks-ds_GalleryBlock-config",
    path: "blocks/ds_GalleryBlock/config",
    component: () => import("/home/runner/work/web-frontend/web-frontend/app/pages/block-tests/blocks/ds_GalleryBlock/config.js")
  },
  {
    name: "block-tests-blocks-ds_ButtonGroupBlock-config",
    path: "blocks/ds_ButtonGroupBlock/config",
    component: () => import("/home/runner/work/web-frontend/web-frontend/app/pages/block-tests/blocks/ds_ButtonGroupBlock/config.js")
  }
]
  },
  {
    name: "news-feed-article",
    path: "/news-feed/:article()",
    component: () => import("/home/runner/work/web-frontend/web-frontend/app/pages/news-feed/[article].vue")
  },
  {
    name: "newsletters-newsletter",
    path: "/newsletters/:newsletter()",
    component: () => import("/home/runner/work/web-frontend/web-frontend/app/pages/newsletters/[newsletter]/index.vue")
  },
  {
    name: "newsletters-newsletter-article",
    path: "/newsletters/:newsletter()/:article()",
    component: () => import("/home/runner/work/web-frontend/web-frontend/app/pages/newsletters/[newsletter]/[article].vue")
  },
  {
    name: component_45stubfxzDPZss3Yt2CkyB1dMX7HanFvYboSw4k6OXAK36gdAMeta?.name,
    path: "/sitemaps-1-sitemap.xml",
    component: component_45stubfxzDPZss3Yt2CkyB1dMX7HanFvYboSw4k6OXAK36gdA
  },
  {
    name: component_45stubfxzDPZss3Yt2CkyB1dMX7HanFvYboSw4k6OXAK36gdAMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubfxzDPZss3Yt2CkyB1dMX7HanFvYboSw4k6OXAK36gdA
  }
]